import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgDropFilesDirective } from 'src/app/directives/directives.index';

export class UploadFile {
  file: string;
}

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css'],
  providers: [NgDropFilesDirective]
})

export class UploadComponent implements OnInit {
  @Input() filesType: string[] = ['zip', 'rar', 'pdf', 'jpg', 'png', 'jpeg', 'xlsx', 'xls', 'docx', 'doc', 'txt', 'csv'];
  files: File[] = [];
  b64Files: string[];
  private loadFilesPromise: Promise<string[]> = Promise.resolve([]);
  @Input() multiple = false;
  @Input() mostrar = false;
  @Input() maxSize: number;
  @Input() scale: string;
  @Output() sendFiles = new EventEmitter<string[]>();
  last: number;
  estaSobreElemento = false;
  constructor(
    public activeModal: NgbActiveModal,
    public dropFile: NgDropFilesDirective
  ) { }

  ngOnInit(): void {
  }

  accept = () => `.${this.filesType.join(', .')}`;

  changeFiles(files: FileList | null | undefined) {
    if (!files) return;
    if (this.files.length >= 1 && !this.multiple) { this.files.splice(0, 1); }
    this.files = this.dropFile.changeFiles(files, this.files, this.filesType, this.multiple, this.maxSize, this.scale);
    this.mostrar = false;
    this.cargar();
  }

  eliminaImg = (ind) => {
    this.files.splice(ind, 1);
    this.cargar();
  }

  checkType(type: string) {
    const image = ['jpg', 'png', 'jpeg'];
    let typeFile = this.filesType.find(x => type.includes(x)) || 'file';
    typeFile = (image.includes(type.trim().toLocaleLowerCase().substr(-4).replace('.', '')) || type.includes('image')) ?
      typeFile = 'image' : typeFile;

    return (typeFile.includes('image') || typeFile.includes('pdf')) ? `-${typeFile}-o` :
      (typeFile.includes('zip') || typeFile.includes('rar')) ? '-zip-o' : (typeFile.includes('docx') || type.includes('word')) ? '-word-o' :
        ((typeFile.includes('xlsx') || type.includes('sheet')) || (typeFile.includes('xls') || type.includes('excel'))) ? '-excel-o' : '';
  }

  cargar() {
    this.loadFilesPromise = Promise.all(this.files.map(file => this.getBase64(file) as Promise<string>));
    this.loadFilesPromise.then((files: string[]) => {
      this.b64Files = files;
      this.sendFiles.emit(this.b64Files);
    });
  }

  modalSave = async () => {
    this.b64Files = await this.loadFilesPromise;
    this.activeModal.close(this.b64Files);
  }

  getBase64 = (file: File) => new Promise((res, rej) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => res(reader.result as string);
    reader.onerror = (error) => rej(error);
  })

  modalEmpty = () => (Object.keys(this.activeModal).length !== 0);

}
